import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: 264,
    backgroundColor: theme.palette.secondary.main + '15',
    borderRadius: theme.app.borderRadius.lg,
    border: `solid 2px ${theme.palette.secondary.main}`,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'unset'
    }
  },
  statusChip: {
    position: 'absolute',
    top: 8,
    right: 8,
    // zIndex: 2,
    fontSize: theme.app.typography.small.fontSize,
    padding: '0 8px',
    height: 24,
    borderRadius: 5,
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: '#fff',
    letterSpacing: 0.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 90,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  cardContent: {
    padding: '16px 24px'
  },

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  cardHeaderIcon: {
    width: 48,
    height: 48,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  cardHeaderSvgIcon: {
    '& path': {
      fill: theme.palette.primary.main
    }
  },

  cardHeaderText: {
    paddingTop: 16,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 600
  },

  cardBodyInformation: {
    paddingTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 13
  },

  cardBodyInformationItem: {
    display: 'flex'
  },

  cardBodyInformationItemFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },

  cardBodyInformationItemIcon: {},

  cardBodyInformationItemText: {
    marginLeft: 8,
    color: theme.app.colors.text.secondary,
    fontWeight: 400,
    fontSize: theme.app.typography.body.fontSize,

    display: 'block',
    maxWidth: 141,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [theme.breakpoints.down('xs')]: {
      maxWidth: 'unset'
    }
  }
}))
